import React from "react";
import "./Vitals.css";
import {
  FaLungs,
  FaThermometerHalf,
  FaHeartbeat,
  FaTint,
} from "react-icons/fa";

const iconMap = {
  heart_rate: <FaHeartbeat className="vital-icon" />,
  respiratory_rate: <FaLungs className="vital-icon" />,
  temperature: <FaThermometerHalf className="vital-icon" />,
  blood_pressure: <FaTint className="vital-icon" />,
};

const colorMap = {
  Normal: "#E0F3FA",
  "Higher than Average": "#FFE6E9",
  "Lower than Average": "#FFE6F1",
};

const Vitals = ({ selectedPatient }) => {
  if (!selectedPatient?.diagnosis_history?.length) {
    return <p>No vitals data available.</p>;
  }

  const latestDiagnosis = selectedPatient.diagnosis_history[0];

  return (
    <div className="vitals-container">
      {latestDiagnosis.respiratory_rate && (
        <div
          className="vital-box"
          style={{
            backgroundColor:
              colorMap[latestDiagnosis.respiratory_rate.levels] || "#f5f5f5",
          }}
        >
          <div className="icon-container">{iconMap["respiratory_rate"]}</div>
          <h3 className="vital-label">Respiratory Rate</h3>
          <p className="vital-value">
            {latestDiagnosis.respiratory_rate.value} breaths/min
          </p>
          <span
            className={`vital-status ${latestDiagnosis.respiratory_rate.levels.toLowerCase()}`}
          >
            {latestDiagnosis.respiratory_rate.levels}
          </span>
        </div>
      )}

      {latestDiagnosis.temperature && (
        <div
          className="vital-box"
          style={{
            backgroundColor:
              colorMap[latestDiagnosis.temperature.levels] || "#f5f5f5",
          }}
        >
          <div className="icon-container">{iconMap["temperature"]}</div>
          <h3 className="vital-label">Temperature</h3>
          <p className="vital-value">{latestDiagnosis.temperature.value}°F</p>
          <span
            className={`vital-status ${latestDiagnosis.temperature.levels.toLowerCase()}`}
          >
            {latestDiagnosis.temperature.levels}
          </span>
        </div>
      )}

      {latestDiagnosis.heart_rate && (
        <div
          className="vital-box"
          style={{
            backgroundColor:
              colorMap[latestDiagnosis.heart_rate.levels] || "#f5f5f5",
          }}
        >
          <div className="icon-container">{iconMap["heart_rate"]}</div>
          <h3 className="vital-label">Heart Rate</h3>
          <p className="vital-value">{latestDiagnosis.heart_rate.value} bpm</p>
          <span
            className={`vital-status ${latestDiagnosis.heart_rate.levels.toLowerCase()}`}
          >
            {latestDiagnosis.heart_rate.levels}
          </span>
        </div>
      )}

      {latestDiagnosis.blood_pressure && (
        <div
          className="vital-box"
          style={{
            backgroundColor:
              colorMap[latestDiagnosis.blood_pressure.systolic.levels] ||
              "#f5f5f5",
          }}
        >
          <div className="icon-container">{iconMap["blood_pressure"]}</div>{" "}
          <h3 className="vital-label">Blood Pressure</h3>
          <p className="vital-value">
            {latestDiagnosis.blood_pressure.systolic.value}/
            {latestDiagnosis.blood_pressure.diastolic.value} mmHg
          </p>
          <span
            className={`vital-status ${latestDiagnosis.blood_pressure.systolic.levels.toLowerCase()}`}
          >
            {latestDiagnosis.blood_pressure.systolic.levels}
          </span>
        </div>
      )}
    </div>
  );
};

export default Vitals;
